import styled from "styled-components";

export const Title = styled.h1`
  font-size: 3em;
  margin-bottom: 0.5em;
  color: #434452;
`;
